<p-toast></p-toast>

<app-page-shell>
    <app-page-hero
        eyebrow="Party Management"
        title="Contact Directory"
        subtitle="Manage customer, driver, employee, broker, laborer, and customs clearance contact links.">
        <div actions>
            <p-button label="New Customer" icon="pi pi-plus" (click)="createParty('Customer')"></p-button>
            <p-button label="New Employee" icon="pi pi-user-plus" severity="secondary" [outlined]="true"
                (click)="createParty('Employee')"></p-button>
        </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

    <app-page-data-panel title="Contact Workspace" subtitle="Use each tab search to query the matching party role.">
        <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange({ index: $event })" styleClass="party-tabs">
            <p-tablist>
                <p-tab [value]="0"><span class="tab-label"><i class="pi pi-user"></i> Customers</span></p-tab>
                <p-tab [value]="1"><span class="tab-label"><i class="pi pi-id-card"></i> Drivers</span></p-tab>
                <p-tab [value]="2"><span class="tab-label"><i class="pi pi-users"></i> Employees</span></p-tab>
                <p-tab [value]="3"><span class="tab-label"><i class="pi pi-briefcase"></i> Laborers</span></p-tab>
                <p-tab [value]="4"><span class="tab-label"><i class="pi pi-shield"></i> Brokers</span></p-tab>
                <p-tab [value]="5"><span class="tab-label"><i class="pi pi-file-check"></i> Customs Agents</span></p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['Customer']" (keyup.enter)="onSearch()"
                                placeholder="Search customers by name, email, or phone" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('Customer')" [disabled]="!searchTerms['Customer']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('Customer')"></p-button>
                        </div>
                    </div>
                    <app-party-table #customerTable [parties]="customers" [totalRecords]="totalCustomers"
                        [isLoading]="isLoading" icon="pi pi-user" emptyMessage="No customers found."
                        [resolveViewLink]="contactDetailRoute"
                        (lazyLoad)="loadData($event, ['Customer'])" (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
                <p-tabpanel [value]="1">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['Driver']" (keyup.enter)="onSearch()"
                                placeholder="Search drivers by name, email, or phone" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('Driver')" [disabled]="!searchTerms['Driver']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('Driver')"></p-button>
                        </div>
                    </div>
                    <app-party-table #driverTable [parties]="drivers" [totalRecords]="totalDrivers" [isLoading]="isLoading"
                        icon="pi pi-id-card" emptyMessage="No drivers found." [resolveViewLink]="contactDetailRoute" (lazyLoad)="loadData($event, ['Driver'])"
                        (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
                <p-tabpanel [value]="2">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['Employee']" (keyup.enter)="onSearch()"
                                placeholder="Search employees by name, email, or phone" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('Employee')" [disabled]="!searchTerms['Employee']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('Employee')"></p-button>
                        </div>
                    </div>
                    <app-party-table #employeeTable [parties]="employees" [totalRecords]="totalEmployees"
                        [isLoading]="isLoading" icon="pi pi-users" emptyMessage="No employees found." [resolveViewLink]="contactDetailRoute"
                        (lazyLoad)="loadData($event, ['Employee'])" (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
                <p-tabpanel [value]="3">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['Laborer']" (keyup.enter)="onSearch()"
                                placeholder="Search laborers by name, email, or phone" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('Laborer')" [disabled]="!searchTerms['Laborer']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('Laborer')"></p-button>
                        </div>
                    </div>
                    <app-party-table #laborerTable [parties]="laborers" [totalRecords]="totalLaborers" [isLoading]="isLoading"
                        icon="pi pi-briefcase" emptyMessage="No laborers found." (lazyLoad)="loadData($event, ['Laborer'])"
                        (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
                <p-tabpanel [value]="4">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['Broker']" (keyup.enter)="onSearch()"
                                placeholder="Search brokers by name, email, or phone" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('Broker')" [disabled]="!searchTerms['Broker']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('Broker')"></p-button>
                        </div>
                    </div>
                    <app-party-table #brokerTable [parties]="brokers" [totalRecords]="totalBrokers" [isLoading]="isLoading"
                        icon="pi pi-shield" emptyMessage="No brokers found." (lazyLoad)="loadData($event, ['Broker'])"
                        (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
                <p-tabpanel [value]="5">
                    <div class="party-toolbar">
                        <span class="search-field">
                            <i class="pi pi-search"></i>
                            <input pInputText [(ngModel)]="searchTerms['CustomsClearanceAgent']" (keyup.enter)="onSearch()"
                                placeholder="Search customs agents by name, email, or phone" />
                        </span>
                        <div class="toolbar-actions">
                            <p-button icon="pi pi-times" [text]="true" severity="secondary"
                                (click)="clearSearch('CustomsClearanceAgent')" [disabled]="!searchTerms['CustomsClearanceAgent']"></p-button>
                            <p-button label="Search" icon="pi pi-search" severity="secondary" [outlined]="true"
                                (click)="onSearch()"></p-button>
                            <p-button label="Add" icon="pi pi-plus" (click)="createParty('CustomsClearanceAgent')"></p-button>
                        </div>
                    </div>
                    <app-party-table #agentTable [parties]="customsClearanceAgents" [totalRecords]="totalCustomsClearanceAgents"
                        [isLoading]="isLoading" icon="pi pi-file-check" emptyMessage="No customs clearance agents found."
                        (lazyLoad)="loadData($event, ['CustomsClearanceAgent'])" (edit)="editParty($event)">
                    </app-party-table>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </app-page-data-panel>
</app-page-shell>

<app-party-quick-create-dialog
    [visible]="quickCreateVisible"
    [mode]="quickCreateMode"
    [record]="quickCreateRecord"
    [owningCompany]="owningCompany"
    [countries]="countries"
    [companyRequired]="quickCreateCompanyRequired"
    [titleOverride]="quickCreateTitle"
    [submitLabel]="quickCreateSubmitLabel"
    (visibleChange)="onQuickCreateVisibilityChanged($event)"
    (created)="onQuickCreateCompleted()"
    (failed)="onQuickCreateFailed($event)">
</app-party-quick-create-dialog>

<p-dialog
    [header]="contactLookupHeader"
    [(visible)]="contactLookupVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(32rem, 92vw)' }"
    (onHide)="closeContactLookup()">
    <div class="lookup-dialog-body">
        <p class="lookup-dialog-copy">
            {{ contactLookupCopy }}
        </p>
        <label class="lookup-dialog-label" for="contactLookupPhoneNumber">Phone Number</label>
        <input
            id="contactLookupPhoneNumber"
            pInputText
            [(ngModel)]="contactLookupPhoneNumber"
            (keyup.enter)="submitContactLookup()"
            placeholder="Enter phone number" />
    </div>
    <ng-template pTemplate="footer">
        <div class="lookup-dialog-footer">
            <p-button label="Cancel" severity="secondary" [outlined]="true" (click)="closeContactLookup()"></p-button>
            <p-button
                label="Continue"
                icon="pi pi-arrow-right"
                [loading]="contactLookupSubmitting"
                [disabled]="!contactLookupPhoneNumber.trim()"
                (click)="submitContactLookup()"></p-button>
        </div>
    </ng-template>
</p-dialog>
